<template>
    <div :class="$slots.trigger ? 'inline-block': null">
        <transition name="fade">
            <div v-if="isVisible"
                 class="fixed
                        w-full
                        h-full
                        inset-0
                        bg-black
                        bg-opacity-75
                        z-topmost
                        desktop:flex
                        desktop:justify-center
                        desktop:items-center"
                 @click.self.prevent="showX? dismiss(): null">
                <div class="flex
                            flex-col
                            m-auto
                            justify-center
                            tablet:max-w-1/2 desktop:max-w-4xl
                            absolute desktop:relative
                            inset-4 desktop:inset-0">
                    <XButton
                        v-if="showX"
                        @on-click="dismiss()"
                        class="flex"
                        :alignment="alignment"
                    />
                    <div class="bg-white text-navy min-w-60 shadow p-4 desktop:p-8 max-h-full overflow-y-auto"
                        :class="roundedBorder">
                        <div class="rounded-md"
                             :class="color">
                            <slot name="contents" />
                            <div v-if="showX"
                                 class="text-center
                                        mt-4
                                        desktop:hidden">
                                <button type="button"
                                        class="buyflow-button-alt"
                                        :class="displayButton"
                                        @click.prevent="dismiss()">
                                    Close
                                </button>
                            </div>
                        </div>

                        <div v-if="$slots.footer"
                             class="mt-6">
                            <slot name="footer" />
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <span v-if="$slots.trigger"
              @click.prevent="show()">
            <slot name="trigger" />
        </span>
    </div>
</template>

<script>
    import XButton from '@/atoms/XButton'
    import { mapActions } from 'vuex'

    export default {
        name: 'SlottedModal',
        components: {
            XButton,
        },
        props: {
            modalType: {
                type: String,
                validator: val => [
                    'info',
                    'success',
                    'warning',
                    'danger',
                    'transparent',
                ].includes(val),
                default: 'info',
            },
            isImmediatelyVisible: {
                type: Boolean,
                default: false,
            },
            alignment: {
                type: String,
                default: 'default',
            },
            borderRadius: {
                type: String,
                validator: val => [
                    'default',
                    'sm',
                    'lg',
                    'xl',
                ].includes(val),
                default: 'default',
            },
            showButton: {
                type: String,
                validator: val => [
                    'hide',
                    'show',
                ].includes(val),
                default: 'show',
            },
            showX: {
                type: Boolean,
                default: true
            }
        },
        data: () => ({
            isVisible: false,
        }),
        watch: {
            isImmediatelyVisible(value) {
                if(value){
                    this.show()
                } else {
                    this.dismiss()
                }
            }
        },
        mounted() {
            if (this.isImmediatelyVisible) {
                this.show()
            }
        },
        computed: {
            color () {
                return {
                    info: 'text-navy border-navy p-6',
                    success: 'text-green-800 border-green-800 border-2 p-6',
                    warning: 'text-yellow-800 border-yellow-800 border-2 p-6',
                    danger: 'text-red-600 border-red-600 border-2 p-6',
                    transparent: 'border-0'
                }[this.modalType]
            },
            roundedBorder() {
                return {
                    sm: 'rounded-sm',
                    default: 'rounded',
                    lg: 'rounded-xl',
                    xl: 'rounded-2xl',
                }[this.borderRadius]
            },
            displayButton() {
                return {
                    hide: 'hidden',
                    show: 'inline-block',
                }[this.showButton]
            },
        },
        methods: {
            ...mapActions([
                'adjustOpenOverlaysCounter'
            ]),
            show() {
                this.isVisible = true
                this.adjustOpenOverlaysCounter({ value: true })
            },
            dismiss() {
                this.isVisible = false
                this.adjustOpenOverlaysCounter({ value: false })
                this.$emit('dismiss')
            },
        },
    }
</script>
